import { Component, input } from '@angular/core';
interface Rows {
  titles: string[]
  text: string[][]
}

@Component({
  selector: 'app-column-text-viewer',
  imports: [],
  templateUrl: './column-text-viewer.html',
  styleUrl: './column-text-viewer.scss',
})

export class ColumnTextViewer {

  rows = input<Rows>({
    titles: [
      'titulo izq',
      'titulo der',
    ],
    text: [
      ['texto derecha', 'texto izquierda'],
      ['texto derecha', 'texto izquierda'],
      ['texto derecha', 'texto izquierda']
    ]
  })

}
